import { getParameterByName } from "../../utils";
import { matchesTCode } from "../providers/utils/helpers";
import get from "lodash/get";
const log = console;

const enviar = (context, queryParams) => {
  matchesTCode(["afl--pml"], function () {
    let orderID = get(context, "state.simulacion.resultado.numTramite", "");
    let nroCliente = get(
      context,
      "state.simulacion.resultado.clientePrestamo.idAltamira",
      ""
    );
    let clickID = getParameterByName("clickid");

    if (orderID && nroCliente && clickID) {
      const pmlurl = new URL(`https://www.w4gb0ubgf.com/?nid=3280`);
      pmlurl.searchParams.append("adv1", orderID);
      pmlurl.searchParams.append("adv2", nroCliente);
      pmlurl.searchParams.append("transaction_id", clickID);
      if (queryParams !== undefined) {
        Object.keys(queryParams).forEach(key => {
          pmlurl.searchParams.append(key, queryParams[key]);
        });
      }

      // PML postback
      fetch(pmlurl.href, {
        method: "GET"
      })
        .then(r => log.log("PML | Success:", r))
        .catch(r => log.error("PML | Error:", r));
    }
  });
};

export default {
  enable() {},
  wait() {
    return true;
  },
  init() {},
  oferta(context) {
    enviar(context, {
      event_id: 22
    });
  },
  paso3(context) {
    enviar(context, {
      event_id: 23
    });
  },
  biometriaOK(context) {
    enviar(context, {
      event_id: 24
    });
  },
  gracias(context) {
    enviar(context);
  }
};
